// wait for the given interval
export function wait(interval: number): Promise<void> {

  return new Promise<void>(resolve => {
    setTimeout(() => resolve(), interval);
  });
}

